import React, { useState } from 'react';
import Button from '~/components/button';
import GeniusModal from '~/components/genius_modal';
import SelectFolderInput from '~/components/select_folder_input';
import { useAppSidebar } from '../../../provider';
const MoveProject = (props) => {
    const { onHide, onMoveProject } = props;
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedFolder, setSelectedFolder] = useState(null);
    const { projectsWorkspaces, isArchivedVisible } = useAppSidebar();
    const onFolderSelect = (folder) => {
        setSelectedFolder(folder);
        ToggleFolderExpansion();
    };
    const filterTreeNodes = (projects) => {
        var _a;
        return (_a = projects === null || projects === void 0 ? void 0 : projects.filter(pw => pw.id !== props.selectedProjectId)) === null || _a === void 0 ? void 0 : _a.map(pw => {
            return Object.assign(Object.assign({}, pw), { children: filterTreeNodes(pw.children) });
        });
    };
    const data = filterTreeNodes(projectsWorkspaces);
    const ToggleFolderExpansion = () => {
        setIsExpanded(!isExpanded);
    };
    const handleMove = () => {
        if (selectedFolder) {
            onMoveProject(selectedFolder.id === 'top-level-option' ? undefined : selectedFolder);
            setSelectedFolder(null);
            onHide();
        }
    };
    const resetUI = () => {
        setSelectedFolder(null);
        setIsExpanded(false);
    };
    return (React.createElement(GeniusModal, { isModalShowing: props.isVisible, alertForm: true, onHide: () => { onHide(); resetUI(); }, bodyContent: React.createElement(React.Fragment, null,
            React.createElement("label", { className: 'modal-input-label', htmlFor: 'Location' }, "Move to"),
            data && React.createElement(SelectFolderInput, { ToggleFolderExpansion: ToggleFolderExpansion, isExpanded: isExpanded, projectsWorkspaces: data, isArchivedVisible: isArchivedVisible, onFolderSelect: onFolderSelect, selectedDisplay: selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.name, selectedId: selectedFolder === null || selectedFolder === void 0 ? void 0 : selectedFolder.id, showTopLevelOption: true })), footerContent: React.createElement(Button, { className: 'modal-action-btn', primary: true, onClick: handleMove, disabled: !selectedFolder }, "Move here") }));
};
export default MoveProject;
